module.exports = __webpack_public_path__ + "img/11.03ba7158.svg";